<template>
    <div>
        <div id="siteSetting-container">
            <el-form ref="initForm" label-width="120px" label-position="left">
                <el-form-item label="当前场地">
                    {{ oriSiteName }}
                </el-form-item>
                <el-form-item label="更改场地" prop="teaCodeArray">
                    <el-select v-model="siteCodeArray" placeholder="请选择" style="width:100%;"
                        @visible-change="handleVisibleChange" @change="handleSiteChange" multiple filterable clearable>
                        <el-option v-for="(item, index) in comboOption.site"
                            :key="item.comboValue"
                            :value="item.comboValue"
                            :label="item.comboName + '（' + item.capacity + '人）' + item.otherInfo"
                            :disabled="item.comboState">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer" style="float:right; margin-top:10px">
            <el-button type="primary" @click="confirm">确定</el-button>
            <el-button @click="closeDialog">取消</el-button>
        </div>
    </div>
</template>

<script>
    import { confirmMsg, showNotify } from "utils/message";

    export default {
        data() {
            return {
                queryForm: {
                    semesterCode: null,
                    classCode: null,
                    deptCode: null,
                    timeOrder: null,
                    siteCode: null,
                    week: null,
                },
                comboOption: {
                    site: null
                },
                oriSiteCode: null,
                oriSiteName: null,
                newSiteCode: null,
                newSiteName: null,
                siteCodeArray: [],
                containerHeight: null,
            }
        },
        mounted() {
            this.containerHeight = document.getElementById('siteSetting-container').offsetHeight;
            this.$emit('updateSiteDialogHeight', this.containerHeight + 65);
        },
        methods: {
            queSiteCombo(){
                this.$api.timetableManage.arrange.queSiteCombo4Change({
                    data: this.queryForm
                }).then((response) => {
                    this.comboOption.site = response.data.data;
                    this.handleComboValue();
                }).catch(error => {
                    console.log(error);
                });
            },
            handleComboValue(){
                //判断当前选中的场地编号是否在下拉框中
                outer: for(let i=0; i<this.siteCodeArray.length; i++){
                    for(let j=0; j<this.comboOption.site.length; j++){
                        if(this.siteCodeArray[i]===this.comboOption.site[j].comboValue && this.comboOption.site[j].comboState===false){
                            continue outer;
                        }
                    }

                    this.siteCodeArray.splice(i, 1);
                    i--;
                }

                this.handleSiteChange();
            },
            handleSiteChange(){
                setTimeout(() => {
                    if(this.containerHeight != document.getElementById('siteSetting-container').offsetHeight){
                        this.containerHeight = document.getElementById('siteSetting-container').offsetHeight;
                        this.$emit('updateSiteDialogHeight', this.containerHeight + 65);
                    }
                }, 100);
            },
            handleVisibleChange(isVisible){
                if(isVisible){
                    this.queSiteCombo();
                }
            },
            confirm() {
                if(this.siteCodeArray.length === 0){
                    this.$message({
                        message: '请选择授课场地',
                        type: 'error'
                    });
                    return;
                }

                let finalSiteInfo = {
                    siteCode: '',
                    siteName: '',
                };
                for(let i=0; i<this.siteCodeArray.length; i++){
                    for(let j=0; j<this.comboOption.site.length; j++){
                        if(this.siteCodeArray[i] === this.comboOption.site[j].comboValue){
                            finalSiteInfo.siteCode += this.comboOption.site[j].comboValue + '+';
                            finalSiteInfo.siteName += this.comboOption.site[j].comboName + '+';
                        }
                    }
                }
                finalSiteInfo.siteCode = finalSiteInfo.siteCode.substring(0, finalSiteInfo.siteCode.length-1);
                finalSiteInfo.siteName = finalSiteInfo.siteName.substring(0, finalSiteInfo.siteName.length-1);

                this.$emit('updateSiteInfo', finalSiteInfo);
            },
            //关闭对话框
            closeDialog() {
                this.$emit('closeSiteSettingDialog');
            },
        },
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// siteSetting.vue?558776b7